import { useEffect, useRef } from "react";
import "./ProductSlider.css";
import HomeBarSub2 from "./HomeBarSub2";
import ArrowRight from "../../assets/icons/ArrowRight.svg";
import { Link } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const SCROLL_AMOUNT = 250;

const HomeBar2 = ({ products, titleImage, eventId, itemQuantity }) => {
  const sliderRef = useRef(null);

  const SHOW_ARROW_COUNT = 7;

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    const slider = sliderRef.current;
    if (slider) {
      if (
        slider.scrollLeft + slider.offsetWidth >=
        slider.scrollWidth - SCROLL_AMOUNT
      ) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        slider.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
      }
    }
  };

  // Auto-scroll removed: user requested manual-only scrolling.

  return (
    <>
      {itemQuantity == 4 ? (
        <div className="homebar2-container_v2 quantity4">
          <div className="homebar2_v2">
            <div className="homebar2-list_v2 quantity4">
              {(() => {
                const visible =
                  Array.isArray(products) && products.length > 0
                    ? products.slice(0, 2)
                    : [];
                const placeholders = 2 - visible.length;
                return (
                  <>
                    {visible.map((productItem, idx) => (
                      <HomeBarSub2
                        product={productItem}
                        key={productItem.item_id || idx}
                      />
                    ))}
                    {Array.from({ length: placeholders }).map((_, idx) => (
                      <div
                        className="product-card2_v2 empty_v2"
                        key={`empty-${idx}`}
                      >
                        <div className="product-card2-internal_v2">
                          <div className="img-padding2_v2" />
                          <div className="product-card2-content_v2">
                            {/* intentionally left blank to preserve layout */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                );
              })()}
            </div>
          </div>

          <div className="imageframe_v2 quantity4">
            <Link to={`/event/${eventId}`}>
              <FallbackImg src={titleImage} alt="bar" />
            </Link>
          </div>

          <div className="homebar2_v2">
            <div className="homebar2-list_v2 quantity4">
              {(() => {
                const visible =
                  Array.isArray(products) && products.length > 0
                    ? products.slice(2, 4)
                    : [];
                const placeholders = 2 - visible.length;
                return (
                  <>
                    {visible.map((productItem, idx) => (
                      <HomeBarSub2
                        product={productItem}
                        key={productItem.item_id || idx}
                      />
                    ))}
                    {Array.from({ length: placeholders }).map((_, idx) => (
                      <div
                        className="product-card2_v2 empty_v2"
                        key={`empty-${idx}`}
                      >
                        <div className="product-card2-internal_v2">
                          <div className="img-padding2_v2" />
                          <div className="product-card2-content_v2">
                            {/* intentionally left blank to preserve layout */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      ) : itemQuantity === 3 ? (
        <div className="homebar2-container_v2">
          <div className="imageframe_v2">
            <Link to={`/event/${eventId}`}>
              <FallbackImg src={titleImage} alt="bar" />
            </Link>
          </div>
          
          <div className="homebar2_v2">
            <div className="homebar2-list_v2">
              {(() => {
                const visible =
                  Array.isArray(products) && products.length > 0
                    ? products.slice(0, 3)
                    : [];
                const placeholders = 3 - visible.length;
                return (
                  <>
                    {visible.map((productItem, idx) => (
                      <HomeBarSub2
                        product={productItem}
                        key={productItem.item_id || idx}
                      />
                    ))}
                    {Array.from({ length: placeholders }).map((_, idx) => (
                      <div
                        className="product-card2_v2 empty_v2"
                        key={`empty-${idx}`}
                      >
                        <div className="product-card2-internal_v2">
                          <div className="img-padding2_v2" />
                          <div className="product-card2-content_v2">
                            {/* intentionally left blank to preserve layout */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      ) : itemQuantity === 2 ? (
        <div className="homebar2-container_v2 quantity2">
          <div className="imageframe_v2 quantity2">
            <Link to={`/event/${eventId}`}>
              <FallbackImg src={titleImage} alt="bar" />
            </Link>
          </div>

          <div className="homebar2_v2">
            <div className="homebar2-list_v2 quantity2">
              {(() => {
                const visible =
                  Array.isArray(products) && products.length > 0
                    ? products.slice(0, 2)
                    : [];
                const placeholders = 2 - visible.length;
                return (
                  <>
                    {visible.map((productItem, idx) => (
                      <HomeBarSub2
                        product={productItem}
                        key={productItem.item_id || idx}
                      />
                    ))}
                    {Array.from({ length: placeholders }).map((_, idx) => (
                      <div
                        className="product-card2_v2 empty_v2"
                        key={`empty-${idx}`}
                      >
                        <div className="product-card2-internal_v2">
                          <div className="img-padding2_v2" />
                          <div className="product-card2-content_v2">
                            {/* intentionally left blank to preserve layout */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default HomeBar2;
